export default {
  // 获取抽奖详细
  findOneDrawRaffleById: '/member/anonymous/amc/findOneDrawRaffleById',
  // 根据抽奖id 获得抽奖下面的所有奖项
  listAwardByDrawRaffleId: '/member/anonymous/amc/listAwardByDrawRaffleId',
  // 获取剩余抽奖次数
  getDrawRaffleTimes: '/member/anonymous/amc/getDrawRaffleTimes',
  // 抽奖(定时抽奖，即时抽奖)
  doDrawRaffle: '/member/anonymous/amc/doDrawRaffle',
  // 获得我的及时抽奖中奖奖品
  listAwardLogsByMemberId: '/member/anonymous/amc/listAwardLogsByMemberId',
  // 兑奖
  acceptPrize: '/member/anonymous/amc/acceptPrize',
  // 保存奖品邮寄地址
  awardSaveExpressInfo: '/member/anonymous/amc/awardSaveExpressInfo',
}